import { LocalStorage } from '/@/modules/core/app/helpers/LocalStorage';
import { LocalStorageKey } from '/@/modules/core/app/constants/app.constants';
import { TableParam } from '/@/modules/core/table/models/TableParam';

export class TableParamCache extends LocalStorage {
  /**
   * @var {string}
   */
  tableKey;

  /**
   * @var {BaseColumns}
   */
  columns;

  constructor(tableKey, columns) {
    super();

    this.tableKey = tableKey;
    this.columns = columns;
  }

  /**
   * @returns {number}
   */
  get page() {
    return this.getTableParam().page;
  }

  /**
   *
   * @param value {number}
   */
  set page(value) {
    const tableParam = this.getTableParam();
    tableParam.page = value;
    this.setTableParam(tableParam);
  }

  /**
   * @returns {null|String}
   */
  get sortField() {
    return this.getTableParam().sortField;
  }

  /**
   * @param value {null|String}
   */
  set sortField(value) {
    const tableParam = this.getTableParam();
    tableParam.sortField = value;
    this.setTableParam(tableParam);
  }

  /**
   *
   * @returns {String}
   */
  get sortOrder() {
    return this.getTableParam().sortOrder;
  }

  /**
   * @param value {null|String}
   */
  set sortOrder(value) {
    const tableParam = this.getTableParam();
    tableParam.sortOrder = value;
    this.setTableParam(tableParam);
  }

  /**
   * @returns {TableFilter[]}
   */
  get selectedTableFilters() {
    const { selectedTableFilters } = this.getTableParam();
    return selectedTableFilters.map((filter) => {
      filter.setColumn(this.columns[filter.columnField], false);
      return filter;
    });
  }

  /**
   * @param value {TableFilter[]}
   */
  set selectedTableFilters(value) {
    const tableParam = this.getTableParam();
    tableParam.selectedTableFilters = value;
    this.setTableParam(tableParam);
  }

  /**
   * @returns {string}
   */
  get ownershipFilter() {
    return this.getTableParam().ownershipFilter;
  }

  /**
   * @param value {string}
   */
  set ownershipFilter(value) {
    const tableParam = this.getTableParam();
    tableParam.ownershipFilter = value;
    this.setTableParam(tableParam);
  }

  /**
   * @returns {string}
   */
  get taxTaskFilter() {
    return this.getTableParam().taxTaskFilter;
  }

  /**
   * @param value {string}
   */
  set taxTaskFilter(value) {
    const tableParam = this.getTableParam();
    tableParam.taxTaskFilter = value;
    this.setTableParam(tableParam);
  }

  /**
   * @protected
   * @returns {TableParam}
   */
  getTableParam() {
    const data = this.getData();
    return new TableParam(data[this.tableKey]);
  }

  /**
   * @protected
   * @param value {TableParam}
   */
  setTableParam(value) {
    const data = this.getData();
    data[this.tableKey] = value;
    this.setData(data);
  }

  /**
   * @protected
   * @returns {Object}
   */
  getData() {
    if (!this.getItem(LocalStorageKey.TABLES)) {
      this.setData({});
    }

    return JSON.parse(this.getItem(LocalStorageKey.TABLES));
  }

  /**
   * @protected
   */
  setData(data) {
    this.setItem(LocalStorageKey.TABLES, JSON.stringify(data));
  }
}
